import Vue from 'vue'

export { default as NutritionLabel } from '@models/nutrition-label'
import { currentStore as store } from '@models/sitestore'

import NutritionLabelVue from '@components/nutrition-label/nutrition-label.vue'
import ComboCalculatorVue from '@components/combo-calculator/combo-calculator.vue'
import DoubleProteinVue from '@components/double-protein/double-protein.vue'
import UserProductVue from '@components/user-product/user-product.vue'

Vue.component('nutrition-label', NutritionLabelVue);
Vue.component('combo-calculator', ComboCalculatorVue);
Vue.component('double-protein', DoubleProteinVue);

var user_product_view = new Vue({
    data: {
        store
    },
    render: function(h) {
        return h(UserProductVue);
    },
    methods: {
        
    }
});

export { user_product_view }
